module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('address-form', {
    ref: "addressForm",
    attrs: {
      "early-invoice-text": _vm.mode === 'business' && 'Wir möchten unsere Bestellung jeweils vor 10 Uhr morgens erhalten.<br>Der Aufpreis für die Öpfelchasper-Frühlieferung beträgt 5 CHF pro Lieferung.',
      "firm-required": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7033c652","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Checkout/Address.vue
// module id = 856
// module chunks = 0